import React, { useEffect, useState } from "react";
import searchIcon from "../../images/search.svg";
import notificationIcon from "../../images/notification.svg";
import plusIcon from "../../images/plus.svg";
import { useAppSelector } from "hooks/reduxHooks";
import { PLACEHOLDERS } from "app-constants/placeholder";
import CreateProjectPopup from "components/CreateProject/CreateProject";
import websiteLogo from "../../images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Dropdown, Flex, Modal, Popover, Tooltip } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  GiftOutlined,
  LogoutOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import ProjectRootSelectionModal from "components/Projects/ProjectRootSelectionModal";
import ReferFriend from "components/Settings/ReferFriend";
import { useDispatch } from "react-redux";
import { changeResetChat, setActiveStep, setSelectedProject } from "store/slices/searcSlice";
import AffiliateProgram from "components/Affiliate/AffiliateProgram";
import { MediumTitle, Title5 } from "components/Common/Typography/Titles";

interface NavbarProps {
  activeButton: string;
  // eslint-disable-next-line no-unused-vars
  handleButtonClick: (buttonName: string) => void;
}

const Navbar: React.FC<NavbarProps> = ({ activeButton, handleButtonClick }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user: any = useAppSelector((state) => state.user.user);
  const isAnyProject: boolean = useAppSelector(
    (state) => state?.user?.userInformation?.generalInfo?.is_project_available
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const UserInfo = useAppSelector((state) => state.user.userInformation);
  const [isOnboardingModalVisible, setIsOnboardingModalVisible] = useState(false);

  const openOnboardingModal = () => setIsOnboardingModalVisible(true);
  const closeOnboardingModal = () => setIsOnboardingModalVisible(false);

  const [isReferModalVisible, setIsReferModalVisible] = useState(false);

  const openReferModal = () => setIsReferModalVisible(true);
  const closeReferModal = () => setIsReferModalVisible(false);

  const queryParams = new URLSearchParams(location.search);
  const handleProjectCreate = () => {
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };
  const handleHomeClick = () => {
    navigate("/");
    dispatch(changeResetChat());
    dispatch(setActiveStep(0));
  };

  const handleSelectProject = () => {
    dispatch(setSelectedProject(1));
  };

  console.log("UserInfo", UserInfo);

  const itemList: any = [
    {
      label: "Candidate Export",
      value: UserInfo?.credits?.export_candidates ? (
        <CheckOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      ),
      color: "green",
    },
    {
      label: "Email Integration",
      value: UserInfo?.credits?.email_integration ? (
        <CheckOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      ),
      color: "green",
    },
    {
      label: "AI Candidate Screening",
      value: UserInfo?.credits?.candidate_screening ? (
        <CheckOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      ),
      color: "green",
    },
    // {
    //   label: "Screening Credits",
    //   value:
    //     UserInfo?.credits?.total_candidate_screening_credits_used +
    //     "/" +
    //     UserInfo?.credits?.total_candidate_screening_credits,
    //   color: "green",
    // },
    // {
    //   label: "Credits Used",
    //   value: UserInfo?.credits?.total_candidate_screening_credits_used,
    //   color: "green",
    // },
    // {
    //   label: "Credits Remaining",
    //   value: UserInfo?.credits?.total_candidate_screening_credits_remaining,
    //   color: "green",
    // },
  ];

  if (UserInfo?.credits?.candidate_screening) {
    itemList.push({
      label: "Screening Credits",
      value:
        UserInfo?.credits?.total_candidate_screening_credits_used +
        "/" +
        UserInfo?.credits?.total_candidate_screening_credits,
      color: "green",
    });
  }

  if (UserInfo.total_credits && UserInfo.total_credits_used) {
    itemList.unshift({
      label: "Profile Views",
      value: UserInfo.total_credits_used + "/" + UserInfo.total_credits,
      color: "green",
    });
  }

  const content = (
    <Flex vertical gap={4}>
      {itemList.map((item: any, Index: any) => (
        <Flex
          key={item.label}
          justify="space-between"
          align="center"
          gap={4}
          className={`border-b pb-2 ${Index === 0 ? "border-t pt-2" : ""}`}
        >
          <MediumTitle text={item.label} className="font-medium" />
          <p>{item.value}</p>
        </Flex>
      ))}
    </Flex>
  );

  const items: Array<{ key: string; label: React.ReactNode }> = [
    {
      key: "1",
      label: (
        <span onClick={openReferModal} className="flex gap-2 items-center">
          <GiftOutlined />
          <span className="ant-menu-title-content">Refer A Friend</span>
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="/logout" className="flex gap-2 items-center">
          <LogoutOutlined />
          <span className="ant-menu-title-content">Logout</span>
        </Link>
      ),
    },
  ];

  // useEffect(() => {
  //   if (jobId) {
  //     handleButtonClick("Filters");
  //   }
  // }, [jobId]);
  // useEffect(() => {
  //   if (isAnyProject) navigate("/create-project");
  // }, [isAnyProject]);

  return (
    <div className="sticky top-0 z-10">
      <div className="py-3.5 px-5 bg-white border-b border-main-border flex items-center justify-between ">
        <div className="flex gap-4 items-center">
          <div onClick={handleHomeClick}>
            <div className="flex items-center justify-center logo-wrapper cursor-pointer">
              <img
                src={websiteLogo}
                alt="LOGO"
                className="main-logo max-w-36 max-h-16 w-auto h-auto block"
              />
            </div>
          </div>

          {/* {location.pathname === "/" ? (
            <button
              className="border-dotted border-2 border-primary-border pt-2 pb-2 pl-5 pr-5 text-primary rounded-md text-xs flex items-center gap-1 font-medium"
              onClick={handleProjectCreate}
            >
              <img src={plusIcon} alt="New project" />
              New project
            </button>
          ) : (
            ""
          )} */}
          {location.pathname === "/" ? (
            <Button
              className="relative font-semibold text-sm text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group "
              onClick={openOnboardingModal}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.99996 4.1665V15.8332M4.16663 9.99984H15.8333"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="svg-path stroke-white group-hover:stroke-primary"
                />
              </svg>
              New Project
            </Button>
            // <div
            //   className="border-dotted cursor-pointer border-2 border-primary-border pt-2 pb-2 pl-5 pr-5 text-primary rounded-md text-xs flex items-center gap-1 font-medium"
            //   // to="/create-project"
            //   onClick={openOnboardingModal}
            // >
            //   <img src={plusIcon} alt="New project" />
            //   New Project
            // </div>
          ) : (
            ""
          )}
        </div>

        {/* {location.pathname === "/" ? (
          <div className="flex items-center gap-4">
            <p className="text-sm font-normal text-text-heading">Search With:</p>
            <div className="rounded-3xl border border-1 border-primary-border bg-bg-secondary">
              <button
                onClick={() => handleButtonClick("AI Search")}
                className={`pt-2 pe-6 pb-2 ps-6 text-sm rounded-3xl transition-all duration-300 ease-in-out w-32 ${activeButton === "AI Search"
                    ? "bg-primary text-white border border-1 border-primary-border"
                    : "text-text-tertiary"
                  }`}
              >
                AI Search
              </button>
              <button
                onClick={() => handleButtonClick("Filters")}
                className={`pt-2 pe-6 pb-2 ps-6 text-sm rounded-3xl transition-all duration-300 ease-in-out w-32 ${activeButton === "Filters"
                    ? "bg-primary text-white border border-1 border-primary-border"
                    : "text-text-tertiary"
                  }`}
              >
                Filters
              </button>
              {/* <button
                onClick={() => handleButtonClick("Research Assistant")}
                className={`pt-2 pe-6 pb-2 ps-6 text-sm rounded-3xl transition-all duration-300 ease-in-out text-nowrap ${
                  activeButton === "Research Assistant"
                    ? "bg-primary text-white border border-1 border-primary-border"
                    : "text-text-tertiary"
                }`}
              >
                Research Assistant
              </button> */}
        {/* </div>
          </div>
        ) : (
          ""
        )} */}

        <div className="flex items-center gap-4">
          {/* <div className="flex items-center gap-4">
            <button>
              <img src={searchIcon} alt="Search" />
            </button>
            <button>
              <img src={notificationIcon} alt="Notifications" />
            </button>
          </div> */}
          <Popover
            content={content}
            title={<Title5 text="Credit Summary" className="font-semibold" />}
          >
            <div
              style={{
                display: "flex",
                padding: "4px 10px",
                lineHeight: "unset",
                alignItems: "center",
                margin: "auto 0",
                gap: "6px",
                fontSize: "16px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
              className="text-primary border border-primary"
            >
              <PlusCircleOutlined />
              <span>
                {UserInfo.total_credits_used ?? 0} / {UserInfo.total_credits ?? 0}
              </span>
            </div>
          </Popover>
          <Dropdown menu={{ items }} placement="bottomLeft">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="rounded-full w-10 h-10 flex justify-center items-center overflow-hidden border border-1 border-secondary-border">
                  <img
                    src={
                      user && user.profile_picture
                        ? user.profile_picture
                        : PLACEHOLDERS.blank_avatar
                    }
                    alt="Avatar"
                  />
                </div>
                <div className="w-3.5 h-3.5 bg-white flex items-center justify-center absolute rounded-full bottom-0 right-0">
                  <p className="w-2.5 h-2.5 bg-success-secondary rounded-full"></p>
                </div>
              </div>
              <div>
                <p className="text-text-secondary text-sm font-semibold">
                  {user ? user.first_name : ""}
                </p>
                <span className="text-text-tertiary text-sm"> {user ? user.email : ""}</span>
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
      {isOpen && <CreateProjectPopup onCancel={handleCancel} />}
      <ProjectRootSelectionModal
        isVisible={isOnboardingModalVisible}
        onClose={closeOnboardingModal}
        setRefresh={handleSelectProject}
      />
      {/* <Modal
        title="Refer A Friend"
        footer={null}
        open={isReferModalVisible}
        onCancel={closeReferModal}
      >
        <ReferFriend isModal={true} />
      </Modal> */}
      <AffiliateProgram isVisible={isReferModalVisible} onClose={closeReferModal} />
    </div>
  );
};

export default Navbar;
